import { render, staticRenderFns } from "./message-container.vue?vue&type=template&id=d90f4db4&scoped=true"
import script from "./message-container.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-container.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-container.vue?vue&type=style&index=0&id=d90f4db4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90f4db4",
  null
  
)

export default component.exports